import API from "../util/api";

export const getShippingMethods = async (params) => {
  let data = null;

  await API.get('/shipping-methods', {params})
    .then(res => {
      data = res.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
}
export const deleteShippingMethod = async (params) => {
  let data = null;

  await API.delete('/shipping-methods/'+params.id)
    .then(res => {
      data = res.data.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
}

export const storeShippingMethod = async (payload) => {
  let data = null;

  await API.post('/shipping-methods', payload)
    .then(res => {
      data = res.data.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
}

export const updateShippingMethod = async (id, payload) => {
  let data = null;

  await API.patch(`/shipping-methods/${id}`, payload)
    .then(res => {
      data = res.data.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
}